<template>
	<div class="locale-flag-selector">
		<shape src="/static/svg/flags/uk.svg" @click.native="onClick('en-gb')" :class="cssClass('en-gb')"/>
		<shape src="/static/svg/flags/fr.svg" @click.native="onClick('fr')" :class="cssClass('fr')"/>
		<shape src="/static/svg/flags/pt.svg" @click.native="onClick('pt')" :class="cssClass('pt')"/>
	</div>
</template>

<script>
export default {
	methods: {
		cssClass (lang) {
			return lang === this.$i18n.locale ? 'active' : ''
		},
		onClick (lang) {
			this.$i18n.locale = lang
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/i18n/LocaleFlagSelector.vue